module.exports = __webpack_public_path__ + "static/media/YF03_0.4254bca6.jpg";